<template>
  <div class="data-box">
    <el-date-picker
      class="date-input"
      :clearable="isClearable"
      :editable="isClearable"
      value-format="yyyy-MM-dd HH:mm:ss"
      v-model="searchForm[startFiled]"
      type="date"
      placeholder="开始日期">
    </el-date-picker>
    <span class="to">至</span>
    <el-date-picker
      value-format="yyyy-MM-dd 23:59:59"
      :clearable="isClearable"
      :editable="isClearable"
      class="date-input"
      v-model="searchForm[endFiled]"
      type="date"
      :picker-options="pickerOptions"
      placeholder="结束日期">
    </el-date-picker>
  </div>
</template>

<script>
import moment from 'moment';
const DEFAULTSTARTTIME = moment().subtract(1, "months").format("YYYY-MM-DD 00:00:00")
const DEFAULTENDTIME = moment().format("YYYY-MM-DD 23:59:59")
export default {
  name: 'QDatePicker',
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    },
    startFiled: {
      type: String,
      default: "startTime"
    },
    endFiled: {
      type: String,
      default: "endTime"
    },
    isDefault: {
      type: Boolean,
      default: true
    },
    isClearable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    searchForm: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('change', newValue)
      }
    },
    pickerOptions() {
      const startTime =  this.searchForm[this.startFiled]
      return {
        disabledDate(time) {
          return time.getTime() < new Date(startTime).getTime()
        }
      }
    },
  },
  mounted() {
    this.reset()
  },
  methods: {
    reset() {
      const startTime = this.searchForm[this.startFiled]
      const nedTTime = this.searchForm[this.endFiled]
      if (!startTime && !nedTTime && this.isDefault) {
        this.searchForm[this.startFiled] = DEFAULTSTARTTIME
        this.searchForm[this.endFiled] = DEFAULTENDTIME
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.data-box {
  width: 240px;
  display: flex;
  .date-input {
    width 110px !important
  }
  >>>.el-input__prefix {
    left: 0;
  }
  >>>.el-input__suffix {
    right: 0;
  }
  >>>.el-input__inner {
    padding: 0 20px 0 25px;
  }
  .to {
    flex: 1;
    text-align: center;
  }
}

</style>